import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './home';
import PortalFooter from "./pfooter";
import PrivacyPolicy from "./privacy";
import TermsOfService from "./terms";
import SaaSPage from "./infopage";
import MenuComponent from "./menu";
import FeaturesPage from "./features";
import Koffieland from "./koffieland";
import Ecosystem from "./ecommerce";
import Demo from "./demo";
import UserPage from "./usertype";
import ShopPage from "./koffieshop";
import RoasterPage from "./wifi";
import BaristaPage from "./ethernet";
import FarmerPage from "./farmer";
import AboutPage from "./bout";
import BookDemoForm from "./bookit";
import ScrollToTop from "./ScrollToTop";
import TeamPage from "./team";
import SupportPage from "./support";
import CertificationsPage from "./certifications";
import CookieConsent from "./CookieConsent";
import LoginPage from "./login";


const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <MenuComponent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/aiagents" element={<SaaSPage />} />
        <Route path="/digitalassets" element={<FeaturesPage />} />
        <Route path="/koffieland" element={<Koffieland />} />
        <Route path="/ecommerce" element={<Ecosystem />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/possys" element={<UserPage />} />
        <Route path="/networks" element={<ShopPage />} />
        <Route path="/wifi" element={<RoasterPage />} />
        <Route path="/ethernet" element={<BaristaPage />} />
        <Route path="/farmerpage" element={<FarmerPage />} />
        <Route path="/about/company" element={<AboutPage />} />
        <Route path="/about/team" element={<TeamPage />} />
        <Route path="/bookit" element={<BookDemoForm />} />
        <Route path="/contact/support" element={<SupportPage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Add more routes as needed */}
      </Routes>
      <CookieConsent />
      <PortalFooter />
    </BrowserRouter>
  );
};

export default App;
